import { Divider, Stack, Button } from '@mui/material';
import { COLOR_MAP } from '../../../constants/ColorNames';
import { DateRange } from 'react-day-picker';

type FooterProps = {
  range: DateRange | undefined;
  handleDateRangeApply: (range: any) => void;
  handleRangeChange: (newRange: any) => void;
}

const Footer = (props: FooterProps) => {
  const {handleDateRangeApply, handleRangeChange, range} = props;
  return (
  <div>
    <Divider
      style={{
        height: '0.1rem',
        backgroundColor: COLOR_MAP.DISABLED,
      }}
      orientation="vertical"
      flexItem
    />
    <Stack
      justifyContent="space-around"
      direction="row"
      sx={{
        padding: '0.8rem',
      }}
      spacing={1}
      width="100%"
    >
      <Button sx={{ height: '32px', textTransform: 'capitalize' }} variant="text" disableRipple onClick={() =>  handleRangeChange(undefined)}>
        Reset
      </Button>

      <Button
        sx={{
          width: '146px',
          height: '32px',
          textTransform: 'capitalize'
        }}
        onClick={() => handleDateRangeApply(range)}
        variant="contained"
      >
        Apply
      </Button>
    </Stack>
  </div>
  )
};
export default Footer;
